const dots = document.querySelectorAll('.dot');
const columns = document.querySelectorAll('.inner-wrapper .row .col-4');
const outerWrapper = document.querySelector('.outer-wrapper');

function updateActiveDot() {
    if (!outerWrapper || columns.length === 0 || dots.length === 0) {
        return;
    }
    const scrollPosition = outerWrapper.scrollLeft;
    const columnWidth = columns[0].offsetWidth;

    const index = Math.floor(scrollPosition / columnWidth);

    dots.forEach(dot => dot.classList.remove('active'));

    if (index >= 0 && index < dots.length) {
        dots[index].classList.add('active');
    }
}

if(outerWrapper){
    outerWrapper.addEventListener('scroll', updateActiveDot);
}
dots.forEach(dot => {
    if (dot) {
        dot.addEventListener('click', () => {
            const targetIndex = dot.getAttribute('data-target');
            if (columns[targetIndex]) {
                outerWrapper.scrollTo({
                    left: columns[targetIndex].offsetLeft,
                    behavior: 'smooth'
                });
            }
        });
    }
});

updateActiveDot();
